class ValueHelper {

    static format_money(value, sign = "£") {
        //noinspection EqualityComparisonWithCoercionJS
        return (value < 0 ? '-' : '') + sign + ValueHelper.format_thousands(Math.abs(parseInt(value) == parseFloat(value) ? parseInt(value) : parseFloat(value).toFixed(2)));
    }

    static format_thousands(value) {
        let parts = value.toString().split(".");
        parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ",");
        return parts.join(".");
    }

    static strcmp(str1, str2) {
        return ( ( str1 === str2 ) ? 0 : ( ( str1 > str2 ) ? 1 : -1 ) );
    }

    static format_bytes(bytes, decimals = 0, separator = ' ') {
        if (bytes === 0) return '0 Bytes';
        let k = 1000;
        let sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'];
        let i = Math.floor(Math.log(bytes) / Math.log(k));
        return parseFloat((bytes / Math.pow(k, i)).toFixed(decimals)) + separator + sizes[i];
    }

    static format_time(seconds) {
        let hours = Math.floor(seconds / 3600);
        let minutes = Math.floor((seconds - (hours * 3600)) / 60);
        seconds = seconds - (hours * 3600) - (minutes * 60);

        if (seconds < 10) seconds = "0" + seconds;
        if (hours > 0) {
            if (minutes < 10) minutes = "0" + minutes;
            return hours + ':' + minutes + ':' + seconds;
        } else {
            return minutes + ':' + seconds;
        }
    }

    static obj_compare(obj1, obj2, noOpposite = null) {
        if (typeof obj1 !== typeof obj2) return false;

        let seenKeys = {};
        let same = true;

        $.each(obj1, function (key, val) {
            if ("undefined" !== typeof seenKeys[key]) {
                return;
            }
            seenKeys[key] = true;

            if (typeof val !== typeof obj2[key]) {
                same = false;
            } else if ("object" === typeof val) {
                same = same && ValueHelper.obj_compare(val, obj2[key]);
            } else if (val !== obj2[key]) {
                same = false;
            }

            if (!same) return false;
        });

        return same && (noOpposite === null || ValueHelper.obj_compare(obj2, obj1, true));
    }


    static str_pad(str, padLength, padStr = "0", padLeft = false) {
        str = "" + str;
        padStr = "" + padStr;
        if (padLength <= str.length) return str;

        let padValue = padStr.repeat(padLength - str.length);

        return padLeft ? padValue + str : str + padValue;
    }

    static strip_html(str) {
        return eotwJSXFactory('div', {unsafeHtml: str}).text();
    }

    static nl2br(str) {
        return str.replace(/\n/,"<br>\n");
    }
}

window.ValueHelper = ValueHelper;
export default ValueHelper;
